/* eslint-disable react/jsx-props-no-spreading */
import { useForm } from '@folklore/forms';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import useContact from '../../hooks/useContact';

import SubmitButton from '../buttons/Submit';
import FormGroup from '../fields/FormGroup';
import TextField from '../fields/Text';
import TextareaField from '../fields/Textarea';

import styles from '../../../styles/forms/login.module.scss';

const propTypes = {
    pageId: PropTypes.string,
    className: PropTypes.string,
    onSuccess: PropTypes.func,
};

const defaultProps = {
    pageId: null,
    className: null,
    onSuccess: null,
};

const ContactForm = ({ pageId, className, onSuccess }) => {
    const intl = useIntl();
    const { send, loading } = useContact();

    const postForm = useCallback((action, data) => send({ ...data, pageId }), [send, pageId]);
    const { fields, onSubmit } = useForm({
        fields: ['email', 'body'],
        postForm,
        onComplete: onSuccess,
    });

    return (
        <form
            className={classNames([styles.container, { [className]: className !== null }])}
            method="post"
            onSubmit={onSubmit}
        >
            <div className={styles.fieldsGroup}>
                <FormGroup
                    {...fields.email}
                    label={<FormattedMessage defaultMessage="Email" description="Form label" />}
                >
                    <TextField
                        {...fields.email}
                        className={classNames(styles.input, styles.inputText)}
                        type="email"
                        required
                        placeholder={intl.formatMessage({
                            defaultMessage: 'your@email.here',
                            description: 'Field placeholder',
                        })}
                    />
                </FormGroup>

                <FormGroup
                    {...fields.body}
                    label={<FormattedMessage defaultMessage="Message" description="Form label" />}
                    className={styles.formGroup}
                >
                    <TextareaField
                        {...fields.body}
                        className={classNames(styles.input, styles.inputTextarea)}
                        required
                        placeholder={intl.formatMessage({
                            defaultMessage: 'Whatever you wish to say...',
                            description: 'Field placeholder',
                        })}
                    />
                </FormGroup>
            </div>
            <div className={styles.actions}>
                <SubmitButton loading={loading} isLarge>
                    <FormattedMessage defaultMessage="Send" description="Form button label" />
                </SubmitButton>
            </div>
        </form>
    );
};
ContactForm.propTypes = propTypes;
ContactForm.defaultProps = defaultProps;

export default ContactForm;
